define('modules/strategy/creatives/views/list',["Underscore", "jQuery", "T1", "T1View", "T1Layout", "text!../templates/grid_item.html", "text!../templates/grid_footer.html", "text!../templates/grid_subItem.html", "T1GridView", "T1Spinner", "collections/creatives", "utils/CreativeUtils", "utils/VideoUtils", "T1Tooltip"], function (_, $, T1, T1View, T1Layout, gridItem, gridFooter, gridSubItem, createGrid, Spinner, Creatives, CreativeUtils, VideoUtils) {
  "use strict";

  var CreativesListView = T1View.extend({
    partials: {
      listItem: gridItem,
      gridFooter: gridFooter,
      gridSubItem: gridSubItem
    },
    headers: [{
      name: "name",
      label: "concept name"
    }, {
      name: "creative-id",
      label: "creative id"
    }, {
      name: "size",
      label: "size"
    }, {
      name: "secure",
      label: "secure"
    }, {
      name: "date-added",
      label: "date added"
    }, {
      name: "start-date",
      label: "start date"
    }, {
      name: "end-date",
      label: "end date"
    }],
    name: "strategyConceptList",
    spinnerOpts: {
      lines: 8,
      length: 2,
      width: 2,
      radius: 2,
      corners: 1,
      rotate: 0,
      trail: 14,
      speed: 1.4
    },
    events: {
      "click .item": "toggle",
      "click .item .icon.include": "includeTarget",
      "mouseenter .topitem": "showConceptLink",
      "mouseleave .topitem": "hideConceptLink",
      "mouseenter .subitem": "showCreativeLink",
      "mouseleave .subitem": "hideCreativeLink",
      "click .jumpToConcept": "clickedJumpToConceptAndCreative",
      "click .jumpToCreative": "clickedJumpToConceptAndCreative"
    },
    creativesCollections: {},
    initialize: function ({
      sharedCollection: sharedCollection
    }) {
      this.searchTerm = "";
      this.sharedCollection = sharedCollection;
    },
    draggableConfigs: {
      allowDrag: true,
      allowMultipleSelection: true,
      handlerTextEl: ".concept"
    },
    eventhubEvents: {
      "strategyCreatives.showActive": function (flag) {
        T1.EventHub.publish("strategyCreativesLoader:stop");
        this.setSearchLoader();
        const collection = this.collection;
        this.showActiveOnly = flag;
        if (this.showActiveOnly) {
          collection.search.set({
            params: [{
              term: "1",
              searchField: "status"
            }]
          });
        } else {
          collection.search.set({});
        }
        this.collection.fetch();
      },
      "bins:droppedConcept": function ({
        selectedList: selectedList
      }) {
        var collection = this.collection;
        for (let i = 0; i < selectedList.length; i++) {
          this.addTarget(collection.get(selectedList[i].id));
        }
      }
    },
    dataEvents: {
      sharedCollection: {
        add: function (model) {
          var id = model.has("concept") ? model.get("concept").id : model.id;
          const $item = this.$(`[data-id="${id}"]`);
          var action = model.get("action");
          var $parent = $item.parent();
          $parent.addClass("selected").find(`.icon.${action}`).addClass("active");
          $parent.find(".children").addClass("parent-selected");
        },
        remove: function (model) {
          var id = model.has("concept") ? model.get("concept").id : model.id;
          var $item = this.$(`[data-id="${id}"]`);
          var $parent = $item.parent();
          $parent.removeClass("selected").find(".icon").removeClass("active");
          $parent.find(".children").removeClass("parent-selected");
        }
      },
      collection: {
        reset: "load",
        search: "search",
        "search.clear": "clearSearch"
      }
    },
    scrollConfigs: {
      target: ".content-holder",
      triggerPoint: 300
    },
    clearSearch: function () {
      var collection = this.collection;
      this.searchTerm = "";
      collection.search.clear();
      collection.search.set({
        params: [{
          term: "1",
          searchField: "status"
        }]
      });
      collection.fetch();
    },
    search: function (term) {
      var collection = this.collection;
      collection.search.set({
        params: [{
          term: term,
          searchField: "name|id"
        }]
      });
      this.searchTerm = term;
      this.setSearchLoader();
      collection.fetch();
    },
    showActiveOnly: true,
    unload: function () {
      this.clearSearch();
      if (this.paginationLayout && this.paginationLayout.unload) {
        this.paginationLayout.unload();
      }
    },
    addChildren: function ({
      entityId: entityId,
      collection: collection,
      container: container
    }) {
      const conceptId = entityId || "";
      const creativesColl = collection || this.getCreativesCollection(conceptId);
      const childrenContainer = container || this.$(`.children-${conceptId}`);
      const serializedData = this.serialize(creativesColl.toJSON());
      var boundAddChildren = this.addChildren.bind(this);
      $.each(serializedData.list, function (index, creativeData) {
        var creativeName = creativeData.name;
        var truncLength = 21;
        const adxTruncLength = 19;
        if (creativeData.hasADXError) {
          truncLength = adxTruncLength;
        }
        creativeData.showName = creativeData.name;
        if (creativeName.length > truncLength) {
          creativeData.showName = `${$.trim(creativeName).substring(0, truncLength)}...`;
        }
      });
      this.renderPartialTemplate({
        template: this.partials.gridSubItem,
        useTemplateHtml: false,
        action: "html",
        targetEl: childrenContainer,
        data: serializedData
      });
      if (creativesColl.count > creativesColl.pageLimit) {
        creativesColl.entityType = "Creative";
        this.paginationLayout = new T1Layout({
          el: () => this.el,
          template: "<div></div>",
          selectorPath: `.pagination-${conceptId}`,
          layout: {}
        });
        this.paginationLayout.layout[`.pagination-${conceptId}`] = [{
          module: "shared",
          viewType: "pagination",
          options: {
            parentEl: this.el,
            collection: creativesColl,
            onSuccess: boundAddChildren,
            indent: "margin: 0 -55px 0 55px"
          }
        }];
        this.paginationLayout.load();
      }
      this.makeTooltips(childrenContainer);
      this.updateScrollBar();
    },
    getCreativesCollection: function (conceptId) {
      if (!this.creativesCollections[conceptId]) {
        const creativesColl = new Creatives([], {
          isPaginated: true,
          pageLimit: 100,
          fetchOptions: {
            with: ["creatives,vendor_pixels,vendor_pixel_domains,vendor_domain,vendor", "atomic_creative_ssl_validators"]
          }
        });
        creativesColl.urlFilter.set({
          entity: "concept",
          id: conceptId
        });
        creativesColl.parent = conceptId;
        this.creativesCollections[conceptId] = creativesColl;
      }
      return this.creativesCollections[conceptId];
    },
    showConceptLink: function (e) {
      $(e.target).find(".concept-link-icon-hold").show();
      $(".topLink").show();
    },
    hideConceptLink: function () {
      $(".concept-link-icon-hold").hide();
    },
    showCreativeLink: function (e) {
      $(e.target).find(".creative-link-icon-hold").show();
      $(".subLink").show();
    },
    hideCreativeLink: function () {
      $(".creative-link-icon-hold").hide();
    },
    clickedJumpToConceptAndCreative: function (e) {
      if (e.currentTarget && e.currentTarget.getAttribute("href")) {
        const link = e.currentTarget.getAttribute("href");
        T1.Location.set(link);
      }
    },
    toggle: function (evt) {
      var self = this;
      var item = $(evt.currentTarget);
      var arrow = item.find(".arrow");
      var iconArrow = arrow.find(".icon-arrow");
      var iconSpinner = arrow.find(".icon-spinner");
      var state = iconArrow.hasClass("expanded");
      var conceptId = item.data("id");
      var childrenContainer = item.closest(".item-wrapper").children(".children");
      var paginationContainer = item.closest(".item-wrapper").next(".pagination");
      if (!arrow.length || arrow.hasClass("hidden") || $(evt.target).hasClass("jumpToConcept") || $(evt.target).hasClass("jumpToCreative")) {
        return;
      }
      this.preventDefault(evt);
      if (state) {
        iconSpinner.spin(false);
        iconArrow.removeClass("expanded loading");
        childrenContainer.hide();
        paginationContainer.hide();
        this.updateScrollBar();
      } else {
        const creativesColl = this.getCreativesCollection(conceptId);
        iconArrow.addClass("loading expanded hide");
        Spinner.apply(iconSpinner, this.spinnerOpts);
        if (this.showActiveOnly) {
          creativesColl.search.set({
            params: [{
              term: "1",
              searchField: "status"
            }]
          });
        } else {
          creativesColl.search.clear();
        }
        creativesColl.fetch({
          success: function () {
            var videos = null;
            if (creativesColl.models) {
              creativesColl.models.forEach(function (model) {
                if (model.get("media_type") === "video") {
                  (videos || (videos = [])).push(model);
                }
              });
            }
            if (!videos || !videos.length) {
              present();
            } else {
              VideoUtils.processCreativesVideoMixins(videos, present);
            }
            function present() {
              iconSpinner.spin(false);
              iconArrow.removeClass("loading hide");
              if (childrenContainer.is(":visible")) {
                self.addChildren({
                  entityId: conceptId
                });
              } else {
                childrenContainer.show();
                if (creativesColl.count > creativesColl.pageLimit) {
                  paginationContainer.show();
                }
              }
              self.updateScrollBar();
            }
          }
        });
      }
    },
    makeTooltips: function (context) {
      T1.Tooltip(context, {
        tooltipEle: context.find(".adx-error"),
        className: "adx-error-tipsy"
      });
      T1.Tooltip(context, {
        tooltipEle: context.find(".adx-warning"),
        className: "adx-warning-tipsy"
      });
    },
    includeTarget: function (evt) {
      var currentTarget = $(evt.currentTarget);
      var id = currentTarget.closest(".item").attr("data-id");
      this.preventDefault(evt);
      this.removeDragClasses();
      this.addTarget(this.collection.get(id));
    },
    addTarget: function (item) {
      const sharedCollection = this.sharedCollection;
      const itemInSharedCollection = sharedCollection.get(item.id);
      if (itemInSharedCollection) {
        sharedCollection.remove(itemInSharedCollection);
      } else {
        if (!item.get("action")) {
          item.set({
            action: "include"
          });
        }
        sharedCollection.add(item);
      }
      const args = {
        item: item.toJSON(),
        wasAdded: itemInSharedCollection === undefined
      };
      T1.EventHub.publish("strategyConcepts:add-remove", args);
    },
    load: function () {
      this.render().then(() => {
        this.collection.search.clear();
        if (!this.loaderSet && !this.collection.loaded) {
          this.loaderSet = true;
          this.setSearchLoader();
        }
        if (this.collection.loaded) {
          T1.EventHub.publish("strategyCreativesLoader:stop");
        }
        T1.Tooltip(this.el, {
          el: ".text",
          offset: "4"
        });
      });
    },
    serialize: function (collectionData) {
      let list = collectionData || this.collection.toJSON();
      var dateFormat = "MM/dd/yy";
      var dateParse = T1.Date.parse;
      const sharedCollection = this.sharedCollection;
      var highlightText = T1.Utils.highlightText;
      const hasSearchTerm = this.searchTerm && this.searchTerm.length;
      const searchTerm = decodeURIComponent(CreativeUtils.replaceSymbolsInName(this.searchTerm));
      var resultData = [];
      var isArrayData = $.isArray(list);
      function processData(data) {
        data = !isArrayData ? data.toJSON() : data;
        data.showName = CreativeUtils.replaceSymbolsInName(data.name);
        data.created_on = dateParse(data.created_on).toString(dateFormat);
        data.start_date = data.start_date ? dateParse(data.start_date).toString(dateFormat) : "--";
        data.end_date = data.end_date ? dateParse(data.end_date).toString(dateFormat) : "--";
        data.isFBX = data.ad_format && data.ad_format === "FBX";
        data.auto_detected_vendors = CreativeUtils.parseVendorListForDisplay(data.autoVendors);
        data.manual_vendors = CreativeUtils.parseVendorListForDisplay(data.manualVendors);
        data.error_vendors = CreativeUtils.parseVendorListForDisplay(data.adxErrorVendors);
        const sslValidator = data.atomic_creative_ssl_validator;
        if (sslValidator && sslValidator.ignored !== "YES") {
          data.sslSecurity = true;
          data.secureWarning = sslValidator.is_https === "NO";
          data.verifiedSecure = sslValidator.is_https === "YES";
          if (sslValidator.is_https === "ERROR" || sslValidator.is_https === "UNKNOWN") {
            data.sslSecurity = false;
          }
          sslValidator.is_https = sslValidator.is_https.charAt(0) + sslValidator.is_https.substr(1).toLowerCase();
        } else {
          data.sslSecurity = false;
        }
        if (collectionData) {
          data.statusClass = data.status !== "1" ? "inactive" : "";
        } else {
          if (hasSearchTerm) {
            data.showName = highlightText(data.showName, searchTerm);
          }
        }
        if (sharedCollection.get(data.id)) {
          data.isIncluded = true;
        }
        return data;
      }
      this.errInfoList = [];
      list = !isArrayData ? list.models : list;
      for (let i = 0; i < list.length; i++) {
        resultData.push(processData(list[i]));
      }
      return {
        list: resultData
      };
    }
  });
  return createGrid(CreativesListView);
});
